module.exports = __webpack_public_path__ + "static/media/david-marcu.8f9581db.jpg";